module.exports = __webpack_public_path__ + "static/media/elan-header-logo.5cecf465.png";